import React from "react";
import { Link } from "react-router-dom";
import MarketingLayout from "./components/MarketingLayout.js";
import MarketingFooterCtas from "./components/MarketingFooterCtas.js";

const VALUES = [
  {
    kicker: "Ship",
    title: "Build in public",
    text: "We prefer working software over slide decks — small releases, honest status, and real user feedback.",
  },
  {
    kicker: "Craft",
    title: "Care about the details",
    text: "Interfaces, prompts, and reliability matter. We sweat the seams users notice every day.",
  },
  {
    kicker: "Focus",
    title: "Stay product-led",
    text: "AI is a tool, not the story. We hire people who want to make useful products, not demos.",
  },
];

const ROLES = [
  {
    title: "Full-stack engineer",
    meta: "Remote · Full-time or contract",
    tag: "Engineering",
    blurb: "React, Node, and product sense. You will own features across chat, preview, and integrations.",
  },
  {
    title: "Product designer",
    meta: "Remote · Full-time or contract",
    tag: "Design",
    blurb: "Shape marketing surfaces and in-product flows so Zolaid feels calm, clear, and trustworthy.",
  },
  {
    title: "AI / applied ML engineer",
    meta: "Remote · Full-time or contract",
    tag: "AI",
    blurb: "Prompt systems, tool routing, and evaluation loops that make the agent reliable for real tasks.",
  },
];

export default function Careers() {
  return (
    <MarketingLayout>
      <div className="marketing-page-content careers-page">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Company</p>
          <h1>Careers at Zolaid</h1>
          <p className="page-lead">
            We are a small team building an AI workspace people actually use. If you care about shipping,
            craft, and clear product thinking — we want to hear from you.
          </p>
        </header>

        <h2 className="marketing-section-title" style={{ marginBottom: "1rem" }}>
          How we work
        </h2>
        <div className="careers-values">
          {VALUES.map((item) => (
            <section key={item.title} className="marketing-section-card">
              <span className="marketing-kicker" aria-hidden>
                {item.kicker}
              </span>
              <h3 className="marketing-section-title">{item.title}</h3>
              <p className="marketing-section-text">{item.text}</p>
            </section>
          ))}
        </div>

        <h2 className="marketing-section-title" style={{ marginBottom: "1rem" }}>
          Open conversations
        </h2>
        <p className="marketing-section-text" style={{ marginBottom: "1rem" }}>
          We hire continuously rather than only through formal postings. These are the roles we are most
          interested in right now — introduce yourself even if the fit is adjacent.
        </p>
        <div className="careers-roles">
          {ROLES.map((role) => (
            <section key={role.title} className="marketing-section-card careers-role">
              <div>
                <h3 className="marketing-section-title" style={{ marginBottom: "0.15rem" }}>
                  {role.title}
                </h3>
                <p className="careers-role-meta">{role.meta}</p>
                <p className="marketing-section-text" style={{ marginTop: "0.65rem" }}>
                  {role.blurb}
                </p>
              </div>
              <span className="careers-role-tag">{role.tag}</span>
            </section>
          ))}
        </div>

        <section className="marketing-section-card">
          <h2 className="marketing-section-title">How to apply</h2>
          <p className="marketing-section-text" style={{ marginBottom: "1rem" }}>
            Email{" "}
            <a href="mailto:hello@zolaid.com" className="contact-link">
              hello@zolaid.com
            </a>{" "}
            with a short note about what you want to work on, links to work you are proud of, and your
            preferred location / availability. No cover-letter template required.
          </p>
          <div className="marketing-cta-row" style={{ marginTop: 0 }}>
            <a href="mailto:hello@zolaid.com" className="marketing-cta">
              Email hello@zolaid.com
            </a>
            <Link to="/Contact" className="marketing-cta marketing-cta--secondary">
              Other inquiries
            </Link>
          </div>
        </section>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
